import * as i0 from '@angular/core';
import { Injectable, Component, Input, ViewChild, NgModule } from '@angular/core';
import * as i1 from '@ngrx/store';
import { select } from '@ngrx/store';
import { acceptedFileTypes, DEPENDENT_VISAS } from 'app-models';
import { Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { getSubTaskDetails, getStepDetails } from 'visa-store';
import { environment } from 'environment-configurations';
import * as i2 from 'base-generate-forms-library';
import * as i3 from 'ngx-toastr';
import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i5 from 'primeng/tooltip';
import { PrimengLibraryModule } from 'primeng-library';

class GenerateFormsNewLibraryService {
    constructor() { }
}
GenerateFormsNewLibraryService.ɵfac = function GenerateFormsNewLibraryService_Factory(t) { return new (t || GenerateFormsNewLibraryService)(); };
GenerateFormsNewLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: GenerateFormsNewLibraryService, factory: GenerateFormsNewLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GenerateFormsNewLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const _c0 = ["fileInput"];
function GenerateFormsNewLibraryComponent_tr_13_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1, " Not Generated ");
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_13_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1, " Form Uploaded");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "small");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r13.i129LastDocDate);
} }
function GenerateFormsNewLibraryComponent_tr_13_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1, " Form Generated");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "small");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r14.i129LastDocDate);
} }
function GenerateFormsNewLibraryComponent_tr_13_a_11_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 18);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_13_a_11_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(2); return ctx_r18.viewGenerateDoc(ctx_r18.i129Src); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_13_a_12_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 19);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_13_a_12_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(2); return ctx_r20.downloadGenerateDoc(ctx_r20.i129Src); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_13_a_13_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 20);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_13_a_13_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(2); return ctx_r22.deleteUploadedDocument("I129", ctx_r22.documentId129, null, null, null); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_13_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2, "I-129");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtemplate(4, GenerateFormsNewLibraryComponent_tr_13_div_4_Template, 2, 0, "div", 5);
    i0.ɵɵtemplate(5, GenerateFormsNewLibraryComponent_tr_13_div_5_Template, 5, 1, "div", 6);
    i0.ɵɵtemplate(6, GenerateFormsNewLibraryComponent_tr_13_div_6_Template, 5, 1, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 8);
    i0.ɵɵelementStart(8, "a", 9);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_13_Template_a_click_8_listener() { i0.ɵɵrestoreView(_r25); const ctx_r24 = i0.ɵɵnextContext(); return ctx_r24.triggerFileUpload(null, null, null, null, "I129"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "a", 10);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_13_Template_a_click_9_listener() { i0.ɵɵrestoreView(_r25); const ctx_r26 = i0.ɵɵnextContext(); return ctx_r26.postGenerateDoc("I129"); });
    i0.ɵɵelement(10, "img", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, GenerateFormsNewLibraryComponent_tr_13_a_11_Template, 1, 0, "a", 12);
    i0.ɵɵtemplate(12, GenerateFormsNewLibraryComponent_tr_13_a_12_Template, 1, 0, "a", 13);
    i0.ɵɵtemplate(13, GenerateFormsNewLibraryComponent_tr_13_a_13_Template, 1, 0, "a", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r1.i129Src && !ctx_r1.i129LastDocDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.generateFormI129 && ctx_r1.uploadedFormI129 && ctx_r1.i129Src && ctx_r1.i129LastDocDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.generateFormI129 && ctx_r1.generateActive129 && ctx_r1.i129Src && ctx_r1.i129LastDocDate);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r1.i129Src);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.i129Src);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.generateFormI129 && ctx_r1.uploadedFormI129 && ctx_r1.i129Src);
} }
function GenerateFormsNewLibraryComponent_tr_14_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1, " Not Generated ");
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_14_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1, " Form Uploaded");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "small");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r28.i907lastDocDate);
} }
function GenerateFormsNewLibraryComponent_tr_14_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1, " Form Generated");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "small");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r29.i907lastDocDate);
} }
function GenerateFormsNewLibraryComponent_tr_14_a_11_Template(rf, ctx) { if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 18);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_14_a_11_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r34); const ctx_r33 = i0.ɵɵnextContext(2); return ctx_r33.viewGenerateDoc(ctx_r33.i907Src); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_14_a_12_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 19);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_14_a_12_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r36); const ctx_r35 = i0.ɵɵnextContext(2); return ctx_r35.downloadGenerateDoc(ctx_r35.i907Src); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_14_a_13_Template(rf, ctx) { if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 20);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_14_a_13_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r38); const ctx_r37 = i0.ɵɵnextContext(2); return ctx_r37.deleteUploadedDocument("I907", ctx_r37.documentId907, null, null, null); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_14_Template(rf, ctx) { if (rf & 1) {
    const _r40 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2, "I-907");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtemplate(4, GenerateFormsNewLibraryComponent_tr_14_div_4_Template, 2, 0, "div", 5);
    i0.ɵɵtemplate(5, GenerateFormsNewLibraryComponent_tr_14_div_5_Template, 5, 1, "div", 6);
    i0.ɵɵtemplate(6, GenerateFormsNewLibraryComponent_tr_14_div_6_Template, 5, 1, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 8);
    i0.ɵɵelementStart(8, "a", 9);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_14_Template_a_click_8_listener() { i0.ɵɵrestoreView(_r40); const ctx_r39 = i0.ɵɵnextContext(); return ctx_r39.triggerFileUpload(null, null, null, null, "I907"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "a", 10);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_14_Template_a_click_9_listener() { i0.ɵɵrestoreView(_r40); const ctx_r41 = i0.ɵɵnextContext(); return ctx_r41.postGenerateDoc("I907"); });
    i0.ɵɵelement(10, "img", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, GenerateFormsNewLibraryComponent_tr_14_a_11_Template, 1, 0, "a", 12);
    i0.ɵɵtemplate(12, GenerateFormsNewLibraryComponent_tr_14_a_12_Template, 1, 0, "a", 13);
    i0.ɵɵtemplate(13, GenerateFormsNewLibraryComponent_tr_14_a_13_Template, 1, 0, "a", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r2.i907Src && !ctx_r2.i907lastDocDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.generateFormI907 && ctx_r2.uploadedFormI907 && ctx_r2.i907Src && ctx_r2.i907lastDocDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.generateFormI907 && ctx_r2.generateActive907 && ctx_r2.i907Src && ctx_r2.i907lastDocDate);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r2.i907Src);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.i907Src);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.generateFormI907 && ctx_r2.uploadedFormI907 && ctx_r2.i907Src);
} }
function GenerateFormsNewLibraryComponent_tr_15_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1, " Not Generated ");
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_15_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1, " Form Uploaded");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "small");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r43 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r43.g28lastDocDate);
} }
function GenerateFormsNewLibraryComponent_tr_15_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1, " Form Generated");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "small");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r44 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r44.g28lastDocDate);
} }
function GenerateFormsNewLibraryComponent_tr_15_a_11_Template(rf, ctx) { if (rf & 1) {
    const _r49 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 18);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_15_a_11_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r49); const ctx_r48 = i0.ɵɵnextContext(2); return ctx_r48.viewGenerateDoc(ctx_r48.g28Src); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_15_a_12_Template(rf, ctx) { if (rf & 1) {
    const _r51 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 19);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_15_a_12_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r51); const ctx_r50 = i0.ɵɵnextContext(2); return ctx_r50.downloadGenerateDoc(ctx_r50.g28Src); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_15_a_13_Template(rf, ctx) { if (rf & 1) {
    const _r53 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 20);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_15_a_13_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r53); const ctx_r52 = i0.ɵɵnextContext(2); return ctx_r52.deleteUploadedDocument("G28", ctx_r52.documentIdG28, null, null, null); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_15_Template(rf, ctx) { if (rf & 1) {
    const _r55 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2, "G-28");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtemplate(4, GenerateFormsNewLibraryComponent_tr_15_div_4_Template, 2, 0, "div", 5);
    i0.ɵɵtemplate(5, GenerateFormsNewLibraryComponent_tr_15_div_5_Template, 5, 1, "div", 6);
    i0.ɵɵtemplate(6, GenerateFormsNewLibraryComponent_tr_15_div_6_Template, 5, 1, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 8);
    i0.ɵɵelementStart(8, "a", 9);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_15_Template_a_click_8_listener() { i0.ɵɵrestoreView(_r55); const ctx_r54 = i0.ɵɵnextContext(); return ctx_r54.triggerFileUpload(null, null, null, null, "G28"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "a", 10);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_15_Template_a_click_9_listener() { i0.ɵɵrestoreView(_r55); const ctx_r56 = i0.ɵɵnextContext(); return ctx_r56.postGenerateDoc("G28"); });
    i0.ɵɵelement(10, "img", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, GenerateFormsNewLibraryComponent_tr_15_a_11_Template, 1, 0, "a", 12);
    i0.ɵɵtemplate(12, GenerateFormsNewLibraryComponent_tr_15_a_12_Template, 1, 0, "a", 13);
    i0.ɵɵtemplate(13, GenerateFormsNewLibraryComponent_tr_15_a_13_Template, 1, 0, "a", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r3.g28Src && !ctx_r3.g28lastDocDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r3.generateFormG28 && ctx_r3.uploadedFormG28 && ctx_r3.g28Src && ctx_r3.g28lastDocDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.generateFormG28 && ctx_r3.generateActiveG28 && ctx_r3.g28Src && ctx_r3.g28lastDocDate);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r3.g28Src);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.g28Src);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r3.generateFormG28 && ctx_r3.uploadedFormG28 && ctx_r3.g28Src);
} }
function GenerateFormsNewLibraryComponent_tr_16_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1, " Not Generated ");
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_16_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1, " Form Generated");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "small");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r58 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r58.g140lastDocDate);
} }
function GenerateFormsNewLibraryComponent_tr_16_a_9_Template(rf, ctx) { if (rf & 1) {
    const _r62 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 18);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_16_a_9_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r62); const ctx_r61 = i0.ɵɵnextContext(2); return ctx_r61.viewGenerateDoc(ctx_r61.gi140Src); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_16_a_10_Template(rf, ctx) { if (rf & 1) {
    const _r64 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 19);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_16_a_10_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r64); const ctx_r63 = i0.ɵɵnextContext(2); return ctx_r63.downloadGenerateDoc(ctx_r63.gi140Src); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_16_Template(rf, ctx) { if (rf & 1) {
    const _r66 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2, "G-1450");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtemplate(4, GenerateFormsNewLibraryComponent_tr_16_div_4_Template, 2, 0, "div", 5);
    i0.ɵɵtemplate(5, GenerateFormsNewLibraryComponent_tr_16_div_5_Template, 5, 1, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "td", 8);
    i0.ɵɵelementStart(7, "a", 10);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_16_Template_a_click_7_listener() { i0.ɵɵrestoreView(_r66); const ctx_r65 = i0.ɵɵnextContext(); return ctx_r65.postGenerateDoc("G1450"); });
    i0.ɵɵelement(8, "img", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, GenerateFormsNewLibraryComponent_tr_16_a_9_Template, 1, 0, "a", 12);
    i0.ɵɵtemplate(10, GenerateFormsNewLibraryComponent_tr_16_a_10_Template, 1, 0, "a", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r4.gi140Src && !ctx_r4.g140lastDocDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.gi140Src && ctx_r4.g140lastDocDate);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r4.gi140Src);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.gi140Src);
} }
function GenerateFormsNewLibraryComponent_tr_17_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1, " Not Generated ");
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_17_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1, " Form Generated");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "small");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r68 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r68.gi145DocDate);
} }
function GenerateFormsNewLibraryComponent_tr_17_a_9_Template(rf, ctx) { if (rf & 1) {
    const _r72 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 18);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_17_a_9_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r72); const ctx_r71 = i0.ɵɵnextContext(2); return ctx_r71.viewGenerateDoc(ctx_r71.gi145Src); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_17_a_10_Template(rf, ctx) { if (rf & 1) {
    const _r74 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 19);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_17_a_10_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r74); const ctx_r73 = i0.ɵɵnextContext(2); return ctx_r73.downloadGenerateDoc(ctx_r73.gi145Src); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_17_Template(rf, ctx) { if (rf & 1) {
    const _r76 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2, "G-1145");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtemplate(4, GenerateFormsNewLibraryComponent_tr_17_div_4_Template, 2, 0, "div", 5);
    i0.ɵɵtemplate(5, GenerateFormsNewLibraryComponent_tr_17_div_5_Template, 5, 1, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "td", 8);
    i0.ɵɵelementStart(7, "a", 10);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_17_Template_a_click_7_listener() { i0.ɵɵrestoreView(_r76); const ctx_r75 = i0.ɵɵnextContext(); return ctx_r75.postGenerateDoc("G1145"); });
    i0.ɵɵelement(8, "img", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, GenerateFormsNewLibraryComponent_tr_17_a_9_Template, 1, 0, "a", 12);
    i0.ɵɵtemplate(10, GenerateFormsNewLibraryComponent_tr_17_a_10_Template, 1, 0, "a", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r5.gi145Src && !ctx_r5.gi145DocDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.gi145Src && ctx_r5.gi145DocDate);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r5.gi145Src);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.gi145Src);
} }
function GenerateFormsNewLibraryComponent_tr_18_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1, " Not Generated ");
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_18_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1, " Form Uploaded");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "small");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r78 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r78.i130lastDocDate);
} }
function GenerateFormsNewLibraryComponent_tr_18_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1, " Form Generated");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "small");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r79 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r79.i130lastDocDate);
} }
function GenerateFormsNewLibraryComponent_tr_18_a_11_Template(rf, ctx) { if (rf & 1) {
    const _r84 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 18);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_18_a_11_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r84); const ctx_r83 = i0.ɵɵnextContext(2); return ctx_r83.viewGenerateDoc(ctx_r83.i130Src); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_18_a_12_Template(rf, ctx) { if (rf & 1) {
    const _r86 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 19);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_18_a_12_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r86); const ctx_r85 = i0.ɵɵnextContext(2); return ctx_r85.downloadGenerateDoc(ctx_r85.i130Src); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_18_a_13_Template(rf, ctx) { if (rf & 1) {
    const _r88 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 20);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_18_a_13_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r88); const ctx_r87 = i0.ɵɵnextContext(2); return ctx_r87.deleteUploadedDocument("I130", ctx_r87.documentId130, null, null, null); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_18_Template(rf, ctx) { if (rf & 1) {
    const _r90 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2, "I-130");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtemplate(4, GenerateFormsNewLibraryComponent_tr_18_div_4_Template, 2, 0, "div", 5);
    i0.ɵɵtemplate(5, GenerateFormsNewLibraryComponent_tr_18_div_5_Template, 5, 1, "div", 6);
    i0.ɵɵtemplate(6, GenerateFormsNewLibraryComponent_tr_18_div_6_Template, 5, 1, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 8);
    i0.ɵɵelementStart(8, "a", 9);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_18_Template_a_click_8_listener() { i0.ɵɵrestoreView(_r90); const ctx_r89 = i0.ɵɵnextContext(); return ctx_r89.triggerFileUpload(null, null, null, null, "I130"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "a", 10);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_18_Template_a_click_9_listener() { i0.ɵɵrestoreView(_r90); const ctx_r91 = i0.ɵɵnextContext(); return ctx_r91.postGenerateDoc("I130"); });
    i0.ɵɵelement(10, "img", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, GenerateFormsNewLibraryComponent_tr_18_a_11_Template, 1, 0, "a", 12);
    i0.ɵɵtemplate(12, GenerateFormsNewLibraryComponent_tr_18_a_12_Template, 1, 0, "a", 13);
    i0.ɵɵtemplate(13, GenerateFormsNewLibraryComponent_tr_18_a_13_Template, 1, 0, "a", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r6.i130Src && !ctx_r6.i130lastDocDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r6.generateFormI130 && ctx_r6.uploadedFormI130 && ctx_r6.i130Src && ctx_r6.i130lastDocDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.generateFormI130 && ctx_r6.generateActive130 && ctx_r6.i130Src && ctx_r6.i130lastDocDate);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r6.i130Src);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.i130Src);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r6.generateFormI130 && ctx_r6.uploadedFormI130 && ctx_r6.i130Src);
} }
function GenerateFormsNewLibraryComponent_tr_19_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1, " Not Generated ");
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_19_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1, " Form Uploaded");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "small");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r93 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r93.i130PREPlastDocDate);
} }
function GenerateFormsNewLibraryComponent_tr_19_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1, " Form Generated");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "small");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r94 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r94.i130PREPlastDocDate);
} }
function GenerateFormsNewLibraryComponent_tr_19_a_11_Template(rf, ctx) { if (rf & 1) {
    const _r99 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 18);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_19_a_11_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r99); const ctx_r98 = i0.ɵɵnextContext(2); return ctx_r98.viewGenerateDoc(ctx_r98.i130PrepSrc); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_19_a_12_Template(rf, ctx) { if (rf & 1) {
    const _r101 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 19);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_19_a_12_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r101); const ctx_r100 = i0.ɵɵnextContext(2); return ctx_r100.downloadGenerateDoc(ctx_r100.i130PrepSrc); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_19_a_13_Template(rf, ctx) { if (rf & 1) {
    const _r103 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 20);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_19_a_13_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r103); const ctx_r102 = i0.ɵɵnextContext(2); return ctx_r102.deleteUploadedDocument("I130PREP", ctx_r102.documentId130PREP, null, null, null); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_19_Template(rf, ctx) { if (rf & 1) {
    const _r105 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2, "I-130 Preparer");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtemplate(4, GenerateFormsNewLibraryComponent_tr_19_div_4_Template, 2, 0, "div", 5);
    i0.ɵɵtemplate(5, GenerateFormsNewLibraryComponent_tr_19_div_5_Template, 5, 1, "div", 6);
    i0.ɵɵtemplate(6, GenerateFormsNewLibraryComponent_tr_19_div_6_Template, 5, 1, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 8);
    i0.ɵɵelementStart(8, "a", 9);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_19_Template_a_click_8_listener() { i0.ɵɵrestoreView(_r105); const ctx_r104 = i0.ɵɵnextContext(); return ctx_r104.triggerFileUpload(null, null, null, null, "I130PREP"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "a", 10);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_19_Template_a_click_9_listener() { i0.ɵɵrestoreView(_r105); const ctx_r106 = i0.ɵɵnextContext(); return ctx_r106.postGenerateDoc("I130PREP"); });
    i0.ɵɵelement(10, "img", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, GenerateFormsNewLibraryComponent_tr_19_a_11_Template, 1, 0, "a", 12);
    i0.ɵɵtemplate(12, GenerateFormsNewLibraryComponent_tr_19_a_12_Template, 1, 0, "a", 13);
    i0.ɵɵtemplate(13, GenerateFormsNewLibraryComponent_tr_19_a_13_Template, 1, 0, "a", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r7.i130PrepSrc && !ctx_r7.i130PREPlastDocDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r7.generateFormI130Prep && ctx_r7.uploadedFormI130PREP && ctx_r7.i130PrepSrc && ctx_r7.i130PREPlastDocDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.generateFormI130Prep && ctx_r7.generateActiveI130Prep && ctx_r7.i130PrepSrc && ctx_r7.i130PREPlastDocDate);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r7.i130PrepSrc);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.i130PrepSrc);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r7.generateFormI130Prep && ctx_r7.uploadedFormI130PREP && ctx_r7.i130PrepSrc);
} }
function GenerateFormsNewLibraryComponent_tr_20_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1, " Not Generated ");
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_20_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1, " Form Uploaded");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "small");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r108 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r108.i130INTPTRlastDocDate);
} }
function GenerateFormsNewLibraryComponent_tr_20_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1, " Form Generated");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "small");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r109 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r109.i130INTPTRlastDocDate);
} }
function GenerateFormsNewLibraryComponent_tr_20_a_11_Template(rf, ctx) { if (rf & 1) {
    const _r114 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 18);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_20_a_11_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r114); const ctx_r113 = i0.ɵɵnextContext(2); return ctx_r113.viewGenerateDoc(ctx_r113.i130IntptrSrc); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_20_a_12_Template(rf, ctx) { if (rf & 1) {
    const _r116 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 19);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_20_a_12_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r116); const ctx_r115 = i0.ɵɵnextContext(2); return ctx_r115.downloadGenerateDoc(ctx_r115.i130IntptrSrc); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_20_a_13_Template(rf, ctx) { if (rf & 1) {
    const _r118 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 20);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_20_a_13_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r118); const ctx_r117 = i0.ɵɵnextContext(2); return ctx_r117.deleteUploadedDocument("I130INTPTR", ctx_r117.documentId130INTPTR, null, null, null); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_20_Template(rf, ctx) { if (rf & 1) {
    const _r120 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2, "I-130 Interpreter");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtemplate(4, GenerateFormsNewLibraryComponent_tr_20_div_4_Template, 2, 0, "div", 5);
    i0.ɵɵtemplate(5, GenerateFormsNewLibraryComponent_tr_20_div_5_Template, 5, 1, "div", 6);
    i0.ɵɵtemplate(6, GenerateFormsNewLibraryComponent_tr_20_div_6_Template, 5, 1, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 8);
    i0.ɵɵelementStart(8, "a", 9);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_20_Template_a_click_8_listener() { i0.ɵɵrestoreView(_r120); const ctx_r119 = i0.ɵɵnextContext(); return ctx_r119.triggerFileUpload(null, null, null, null, "I130INTPTR"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "a", 10);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_20_Template_a_click_9_listener() { i0.ɵɵrestoreView(_r120); const ctx_r121 = i0.ɵɵnextContext(); return ctx_r121.postGenerateDoc("I130INTPTR"); });
    i0.ɵɵelement(10, "img", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, GenerateFormsNewLibraryComponent_tr_20_a_11_Template, 1, 0, "a", 12);
    i0.ɵɵtemplate(12, GenerateFormsNewLibraryComponent_tr_20_a_12_Template, 1, 0, "a", 13);
    i0.ɵɵtemplate(13, GenerateFormsNewLibraryComponent_tr_20_a_13_Template, 1, 0, "a", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r8.i130IntptrSrc && !ctx_r8.i130INTPTRlastDocDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r8.generateFormI130INTPTR && ctx_r8.uploadedFormI130INTPTR && ctx_r8.i130IntptrSrc && ctx_r8.i130INTPTRlastDocDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.generateFormI130INTPTR && ctx_r8.generateActiveI130INTPTR && ctx_r8.i130IntptrSrc && ctx_r8.i130INTPTRlastDocDate);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r8.i130IntptrSrc);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.i130IntptrSrc);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r8.generateFormI130INTPTR && ctx_r8.uploadedFormI130INTPTR && ctx_r8.i130IntptrSrc);
} }
function GenerateFormsNewLibraryComponent_tr_21_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1, " Not Generated ");
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_21_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1, " Form Uploaded");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "small");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r123 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r123.i130AlastDocDate);
} }
function GenerateFormsNewLibraryComponent_tr_21_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1, " Form Generated");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "small");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r124 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r124.i130AlastDocDate);
} }
function GenerateFormsNewLibraryComponent_tr_21_a_11_Template(rf, ctx) { if (rf & 1) {
    const _r129 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 18);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_21_a_11_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r129); const ctx_r128 = i0.ɵɵnextContext(2); return ctx_r128.viewGenerateDoc(ctx_r128.i130ASrc); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_21_a_12_Template(rf, ctx) { if (rf & 1) {
    const _r131 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 19);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_21_a_12_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r131); const ctx_r130 = i0.ɵɵnextContext(2); return ctx_r130.downloadGenerateDoc(ctx_r130.i130ASrc); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_21_a_13_Template(rf, ctx) { if (rf & 1) {
    const _r133 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 20);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_21_a_13_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r133); const ctx_r132 = i0.ɵɵnextContext(2); return ctx_r132.deleteUploadedDocument("I130A", ctx_r132.documentId130A, null, null, null); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_tr_21_Template(rf, ctx) { if (rf & 1) {
    const _r135 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2, "I-130A");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtemplate(4, GenerateFormsNewLibraryComponent_tr_21_div_4_Template, 2, 0, "div", 5);
    i0.ɵɵtemplate(5, GenerateFormsNewLibraryComponent_tr_21_div_5_Template, 5, 1, "div", 6);
    i0.ɵɵtemplate(6, GenerateFormsNewLibraryComponent_tr_21_div_6_Template, 5, 1, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 8);
    i0.ɵɵelementStart(8, "a", 9);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_21_Template_a_click_8_listener() { i0.ɵɵrestoreView(_r135); const ctx_r134 = i0.ɵɵnextContext(); return ctx_r134.triggerFileUpload(null, null, null, null, "I130A"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "a", 10);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_tr_21_Template_a_click_9_listener() { i0.ɵɵrestoreView(_r135); const ctx_r136 = i0.ɵɵnextContext(); return ctx_r136.postGenerateDoc("I130A"); });
    i0.ɵɵelement(10, "img", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, GenerateFormsNewLibraryComponent_tr_21_a_11_Template, 1, 0, "a", 12);
    i0.ɵɵtemplate(12, GenerateFormsNewLibraryComponent_tr_21_a_12_Template, 1, 0, "a", 13);
    i0.ɵɵtemplate(13, GenerateFormsNewLibraryComponent_tr_21_a_13_Template, 1, 0, "a", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r9.i130ASrc && !ctx_r9.i130AlastDocDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r9.generateFormI130A && ctx_r9.uploadedFormI130A && ctx_r9.i130ASrc && ctx_r9.i130AlastDocDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.generateFormI130A && ctx_r9.generateActive130A && ctx_r9.i130ASrc && ctx_r9.i130AlastDocDate);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r9.i130ASrc);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.i130ASrc);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r9.generateFormI130A && ctx_r9.uploadedFormI130A && ctx_r9.i130ASrc);
} }
function GenerateFormsNewLibraryComponent_ng_container_22_ng_container_1_tr_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1, " Not Generated ");
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_ng_container_22_ng_container_1_tr_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1, " Form Uploaded");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "small");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const comItem_r141 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(comItem_r141.lastDocDate);
} }
function GenerateFormsNewLibraryComponent_ng_container_22_ng_container_1_tr_1_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1, " Form Generated");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "small");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const comItem_r141 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(comItem_r141.lastDocDate);
} }
function GenerateFormsNewLibraryComponent_ng_container_22_ng_container_1_tr_1_a_11_Template(rf, ctx) { if (rf & 1) {
    const _r153 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 18);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_ng_container_22_ng_container_1_tr_1_a_11_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r153); const comItem_r141 = i0.ɵɵnextContext().$implicit; const ctx_r151 = i0.ɵɵnextContext(3); return ctx_r151.viewGenerateDoc(comItem_r141.fileSrc); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_ng_container_22_ng_container_1_tr_1_a_12_Template(rf, ctx) { if (rf & 1) {
    const _r156 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 19);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_ng_container_22_ng_container_1_tr_1_a_12_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r156); const comItem_r141 = i0.ɵɵnextContext().$implicit; const ctx_r154 = i0.ɵɵnextContext(3); return ctx_r154.downloadGenerateDoc(comItem_r141.fileSrc); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_ng_container_22_ng_container_1_tr_1_a_13_Template(rf, ctx) { if (rf & 1) {
    const _r159 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 20);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_ng_container_22_ng_container_1_tr_1_a_13_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r159); const ctx_r158 = i0.ɵɵnextContext(); const comItem_r141 = ctx_r158.$implicit; const i_r142 = ctx_r158.index; const ctx_r157 = i0.ɵɵnextContext(3); return ctx_r157.deleteUploadedDocument(comItem_r141.code, comItem_r141.documentId, "common", i_r142, null); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_ng_container_22_ng_container_1_tr_1_Template(rf, ctx) { if (rf & 1) {
    const _r161 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtemplate(4, GenerateFormsNewLibraryComponent_ng_container_22_ng_container_1_tr_1_div_4_Template, 2, 0, "div", 5);
    i0.ɵɵtemplate(5, GenerateFormsNewLibraryComponent_ng_container_22_ng_container_1_tr_1_div_5_Template, 5, 1, "div", 6);
    i0.ɵɵtemplate(6, GenerateFormsNewLibraryComponent_ng_container_22_ng_container_1_tr_1_div_6_Template, 5, 1, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 8);
    i0.ɵɵelementStart(8, "a", 9);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_ng_container_22_ng_container_1_tr_1_Template_a_click_8_listener() { i0.ɵɵrestoreView(_r161); const i_r142 = ctx.index; const comItem_r141 = ctx.$implicit; const ctx_r160 = i0.ɵɵnextContext(3); return ctx_r160.triggerFileUpload("common", i_r142, null, comItem_r141.applicantId, comItem_r141.code); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "a", 10);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_ng_container_22_ng_container_1_tr_1_Template_a_click_9_listener() { i0.ɵɵrestoreView(_r161); const comItem_r141 = ctx.$implicit; const ctx_r162 = i0.ɵɵnextContext(3); return ctx_r162.postDependentGenerateDoc(comItem_r141.code, comItem_r141.applicantId, "false", comItem_r141.relationshipCode); });
    i0.ɵɵelement(10, "img", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, GenerateFormsNewLibraryComponent_ng_container_22_ng_container_1_tr_1_a_11_Template, 1, 0, "a", 12);
    i0.ɵɵtemplate(12, GenerateFormsNewLibraryComponent_ng_container_22_ng_container_1_tr_1_a_12_Template, 1, 0, "a", 13);
    i0.ɵɵtemplate(13, GenerateFormsNewLibraryComponent_ng_container_22_ng_container_1_tr_1_a_13_Template, 1, 0, "a", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const comItem_r141 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(comItem_r141.name);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !comItem_r141.fileSrc && !comItem_r141.lastDocDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !comItem_r141.isGenerated && comItem_r141.isUploaded && comItem_r141.fileSrc && comItem_r141.lastDocDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", comItem_r141.isGenerated && comItem_r141.isActive && comItem_r141.fileSrc && comItem_r141.lastDocDate);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", comItem_r141.fileSrc);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", comItem_r141.fileSrc);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !comItem_r141.isGenerated && comItem_r141.isUploaded && comItem_r141.fileSrc);
} }
function GenerateFormsNewLibraryComponent_ng_container_22_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GenerateFormsNewLibraryComponent_ng_container_22_ng_container_1_tr_1_Template, 14, 7, "tr", 21);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r137 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r137.formDataArray.common);
} }
function GenerateFormsNewLibraryComponent_ng_container_22_tr_2_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1, " Not Generated ");
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_ng_container_22_tr_2_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1, " Form Uploaded");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "small");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r163 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(item_r163.lastDocDate);
} }
function GenerateFormsNewLibraryComponent_ng_container_22_tr_2_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1, " Form Generated");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "small");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r163 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(item_r163.lastDocDate);
} }
function GenerateFormsNewLibraryComponent_ng_container_22_tr_2_a_11_Template(rf, ctx) { if (rf & 1) {
    const _r175 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 18);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_ng_container_22_tr_2_a_11_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r175); const item_r163 = i0.ɵɵnextContext().$implicit; const ctx_r173 = i0.ɵɵnextContext(2); return ctx_r173.viewGenerateDoc(item_r163.fileSrc); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_ng_container_22_tr_2_a_12_Template(rf, ctx) { if (rf & 1) {
    const _r178 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 19);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_ng_container_22_tr_2_a_12_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r178); const item_r163 = i0.ɵɵnextContext().$implicit; const ctx_r176 = i0.ɵɵnextContext(2); return ctx_r176.downloadGenerateDoc(item_r163.fileSrc); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_ng_container_22_tr_2_a_13_Template(rf, ctx) { if (rf & 1) {
    const _r181 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 20);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_ng_container_22_tr_2_a_13_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r181); const ctx_r180 = i0.ɵɵnextContext(); const item_r163 = ctx_r180.$implicit; const i_r164 = ctx_r180.index; const ctx_r179 = i0.ɵɵnextContext(2); return ctx_r179.deleteUploadedDocument(item_r163.code, item_r163.documentId, "primary", i_r164, null); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_ng_container_22_tr_2_Template(rf, ctx) { if (rf & 1) {
    const _r183 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtemplate(4, GenerateFormsNewLibraryComponent_ng_container_22_tr_2_div_4_Template, 2, 0, "div", 5);
    i0.ɵɵtemplate(5, GenerateFormsNewLibraryComponent_ng_container_22_tr_2_div_5_Template, 5, 1, "div", 6);
    i0.ɵɵtemplate(6, GenerateFormsNewLibraryComponent_ng_container_22_tr_2_div_6_Template, 5, 1, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 8);
    i0.ɵɵelementStart(8, "a", 9);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_ng_container_22_tr_2_Template_a_click_8_listener() { i0.ɵɵrestoreView(_r183); const i_r164 = ctx.index; const item_r163 = ctx.$implicit; const ctx_r182 = i0.ɵɵnextContext(2); return ctx_r182.triggerFileUpload("primary", i_r164, null, item_r163.applicantId, item_r163.code); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "a", 10);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_ng_container_22_tr_2_Template_a_click_9_listener() { i0.ɵɵrestoreView(_r183); const item_r163 = ctx.$implicit; const ctx_r184 = i0.ɵɵnextContext(2); return ctx_r184.postDependentGenerateDoc(item_r163.code, item_r163.applicantId, "false", item_r163.relationshipCode); });
    i0.ɵɵelement(10, "img", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, GenerateFormsNewLibraryComponent_ng_container_22_tr_2_a_11_Template, 1, 0, "a", 12);
    i0.ɵɵtemplate(12, GenerateFormsNewLibraryComponent_ng_container_22_tr_2_a_12_Template, 1, 0, "a", 13);
    i0.ɵɵtemplate(13, GenerateFormsNewLibraryComponent_ng_container_22_tr_2_a_13_Template, 1, 0, "a", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r163 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r163.name);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !item_r163.fileSrc && !item_r163.lastDocDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !item_r163.isGenerated && item_r163.isUploaded && item_r163.fileSrc && item_r163.lastDocDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r163.isGenerated && item_r163.isActive && item_r163.fileSrc && item_r163.lastDocDate);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", item_r163.fileSrc);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r163.fileSrc);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !item_r163.isGenerated && item_r163.isUploaded && item_r163.fileSrc);
} }
function GenerateFormsNewLibraryComponent_ng_container_22_ng_container_3_tr_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1, " Not Generated ");
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_ng_container_22_ng_container_3_tr_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1, " Form Uploaded");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "small");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const secApplicant_r187 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(secApplicant_r187.lastDocDate);
} }
function GenerateFormsNewLibraryComponent_ng_container_22_ng_container_3_tr_1_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1, " Form Generated");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "small");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const secApplicant_r187 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(secApplicant_r187.lastDocDate);
} }
function GenerateFormsNewLibraryComponent_ng_container_22_ng_container_3_tr_1_a_11_Template(rf, ctx) { if (rf & 1) {
    const _r199 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 18);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_ng_container_22_ng_container_3_tr_1_a_11_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r199); const secApplicant_r187 = i0.ɵɵnextContext().$implicit; const ctx_r197 = i0.ɵɵnextContext(3); return ctx_r197.viewGenerateDoc(secApplicant_r187.fileSrc); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_ng_container_22_ng_container_3_tr_1_a_12_Template(rf, ctx) { if (rf & 1) {
    const _r202 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 19);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_ng_container_22_ng_container_3_tr_1_a_12_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r202); const secApplicant_r187 = i0.ɵɵnextContext().$implicit; const ctx_r200 = i0.ɵɵnextContext(3); return ctx_r200.downloadGenerateDoc(secApplicant_r187.fileSrc); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_ng_container_22_ng_container_3_tr_1_a_13_Template(rf, ctx) { if (rf & 1) {
    const _r205 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 20);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_ng_container_22_ng_container_3_tr_1_a_13_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r205); const ctx_r206 = i0.ɵɵnextContext(); const secApplicant_r187 = ctx_r206.$implicit; const i_r188 = ctx_r206.index; const item1_r185 = i0.ɵɵnextContext().$implicit; const ctx_r203 = i0.ɵɵnextContext(2); return ctx_r203.deleteUploadedDocument(item1_r185.code, secApplicant_r187.documentId, "secondary", i_r188, null); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_ng_container_22_ng_container_3_tr_1_Template(rf, ctx) { if (rf & 1) {
    const _r209 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtemplate(4, GenerateFormsNewLibraryComponent_ng_container_22_ng_container_3_tr_1_div_4_Template, 2, 0, "div", 5);
    i0.ɵɵtemplate(5, GenerateFormsNewLibraryComponent_ng_container_22_ng_container_3_tr_1_div_5_Template, 5, 1, "div", 6);
    i0.ɵɵtemplate(6, GenerateFormsNewLibraryComponent_ng_container_22_ng_container_3_tr_1_div_6_Template, 5, 1, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 8);
    i0.ɵɵelementStart(8, "a", 9);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_ng_container_22_ng_container_3_tr_1_Template_a_click_8_listener() { i0.ɵɵrestoreView(_r209); const i_r188 = ctx.index; const secApplicant_r187 = ctx.$implicit; const item1_r185 = i0.ɵɵnextContext().$implicit; const ctx_r207 = i0.ɵɵnextContext(2); return ctx_r207.triggerFileUpload("secondary", i_r188, null, secApplicant_r187.applicantId, item1_r185.code); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "a", 10);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_ng_container_22_ng_container_3_tr_1_Template_a_click_9_listener() { i0.ɵɵrestoreView(_r209); const secApplicant_r187 = ctx.$implicit; const item1_r185 = i0.ɵɵnextContext().$implicit; const ctx_r210 = i0.ɵɵnextContext(2); return ctx_r210.postDependentGenerateDoc(item1_r185.code, secApplicant_r187.applicantId, "false", secApplicant_r187.relationshipCode); });
    i0.ɵɵelement(10, "img", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, GenerateFormsNewLibraryComponent_ng_container_22_ng_container_3_tr_1_a_11_Template, 1, 0, "a", 12);
    i0.ɵɵtemplate(12, GenerateFormsNewLibraryComponent_ng_container_22_ng_container_3_tr_1_a_12_Template, 1, 0, "a", 13);
    i0.ɵɵtemplate(13, GenerateFormsNewLibraryComponent_ng_container_22_ng_container_3_tr_1_a_13_Template, 1, 0, "a", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const secApplicant_r187 = ctx.$implicit;
    const item1_r185 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", secApplicant_r187.applicantName ? item1_r185.name + " (" + secApplicant_r187.applicantName + ")" : item1_r185.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !secApplicant_r187.fileSrc && !secApplicant_r187.lastDocDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !secApplicant_r187.isGenerated && secApplicant_r187.isUploaded && secApplicant_r187.fileSrc && secApplicant_r187.lastDocDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", secApplicant_r187.isGenerated && secApplicant_r187.isActive && secApplicant_r187.fileSrc && secApplicant_r187.lastDocDate);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", secApplicant_r187.fileSrc);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", secApplicant_r187.fileSrc);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !secApplicant_r187.isGenerated && secApplicant_r187.isUploaded && secApplicant_r187.fileSrc);
} }
function GenerateFormsNewLibraryComponent_ng_container_22_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GenerateFormsNewLibraryComponent_ng_container_22_ng_container_3_tr_1_Template, 14, 7, "tr", 21);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item1_r185 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", item1_r185.secondaryApplicantNameList);
} }
function GenerateFormsNewLibraryComponent_ng_container_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GenerateFormsNewLibraryComponent_ng_container_22_ng_container_1_Template, 2, 1, "ng-container", 4);
    i0.ɵɵtemplate(2, GenerateFormsNewLibraryComponent_ng_container_22_tr_2_Template, 14, 7, "tr", 21);
    i0.ɵɵtemplate(3, GenerateFormsNewLibraryComponent_ng_container_22_ng_container_3_Template, 2, 1, "ng-container", 21);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r10.dependentFormInfo == null ? null : ctx_r10.dependentFormInfo.formDetail) && (ctx_r10.dependentFormInfo == null ? null : ctx_r10.dependentFormInfo.formDetail == null ? null : ctx_r10.dependentFormInfo.formDetail.govtAgencyCode) != "USCIS");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r10.formDataArray.primary);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r10.formDataArray.secondary);
} }
function GenerateFormsNewLibraryComponent_ng_container_23_ng_container_1_tr_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1, " Not Generated ");
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_ng_container_23_ng_container_1_tr_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1, " Form Uploaded");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "small");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r217 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(item_r217.lastDocDate);
} }
function GenerateFormsNewLibraryComponent_ng_container_23_ng_container_1_tr_1_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1, " Form Generated");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "small");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r217 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(item_r217.lastDocDate);
} }
function GenerateFormsNewLibraryComponent_ng_container_23_ng_container_1_tr_1_a_11_Template(rf, ctx) { if (rf & 1) {
    const _r229 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 18);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_ng_container_23_ng_container_1_tr_1_a_11_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r229); const item_r217 = i0.ɵɵnextContext().$implicit; const ctx_r227 = i0.ɵɵnextContext(3); return ctx_r227.viewGenerateDoc(item_r217.fileSrc); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_ng_container_23_ng_container_1_tr_1_a_12_Template(rf, ctx) { if (rf & 1) {
    const _r232 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 19);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_ng_container_23_ng_container_1_tr_1_a_12_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r232); const item_r217 = i0.ɵɵnextContext().$implicit; const ctx_r230 = i0.ɵɵnextContext(3); return ctx_r230.downloadGenerateDoc(item_r217.fileSrc); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_ng_container_23_ng_container_1_tr_1_a_13_Template(rf, ctx) { if (rf & 1) {
    const _r235 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 20);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_ng_container_23_ng_container_1_tr_1_a_13_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r235); const ctx_r236 = i0.ɵɵnextContext(); const item_r217 = ctx_r236.$implicit; const i_r218 = ctx_r236.index; const ctx_r234 = i0.ɵɵnextContext(); const item1_r214 = ctx_r234.$implicit; const index_r215 = ctx_r234.index; const ctx_r233 = i0.ɵɵnextContext(2); return ctx_r233.deleteUploadedDocument(item1_r214.formType.code, item_r217.documentId, "dependentForm", index_r215, i_r218); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsNewLibraryComponent_ng_container_23_ng_container_1_tr_1_Template(rf, ctx) { if (rf & 1) {
    const _r239 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtemplate(4, GenerateFormsNewLibraryComponent_ng_container_23_ng_container_1_tr_1_div_4_Template, 2, 0, "div", 5);
    i0.ɵɵtemplate(5, GenerateFormsNewLibraryComponent_ng_container_23_ng_container_1_tr_1_div_5_Template, 5, 1, "div", 6);
    i0.ɵɵtemplate(6, GenerateFormsNewLibraryComponent_ng_container_23_ng_container_1_tr_1_div_6_Template, 5, 1, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 8);
    i0.ɵɵelementStart(8, "a", 9);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_ng_container_23_ng_container_1_tr_1_Template_a_click_8_listener() { i0.ɵɵrestoreView(_r239); const i_r218 = ctx.index; const item_r217 = ctx.$implicit; const ctx_r238 = i0.ɵɵnextContext(); const index_r215 = ctx_r238.index; const item1_r214 = ctx_r238.$implicit; const ctx_r237 = i0.ɵɵnextContext(2); return ctx_r237.triggerFileUpload("dependentForm", index_r215, i_r218, item_r217.familyId, item1_r214.formType.code); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "a", 10);
    i0.ɵɵlistener("click", function GenerateFormsNewLibraryComponent_ng_container_23_ng_container_1_tr_1_Template_a_click_9_listener() { i0.ɵɵrestoreView(_r239); const item_r217 = ctx.$implicit; const item1_r214 = i0.ɵɵnextContext().$implicit; const ctx_r240 = i0.ɵɵnextContext(2); return ctx_r240.postDependentGenerateDoc(item1_r214.formType == null ? null : item1_r214.formType.code, item_r217.id, item_r217.primaryApplicant, item_r217.relationshipCode); });
    i0.ɵɵelement(10, "img", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, GenerateFormsNewLibraryComponent_ng_container_23_ng_container_1_tr_1_a_11_Template, 1, 0, "a", 12);
    i0.ɵɵtemplate(12, GenerateFormsNewLibraryComponent_ng_container_23_ng_container_1_tr_1_a_12_Template, 1, 0, "a", 13);
    i0.ɵɵtemplate(13, GenerateFormsNewLibraryComponent_ng_container_23_ng_container_1_tr_1_a_13_Template, 1, 0, "a", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r217 = ctx.$implicit;
    const item1_r214 = i0.ɵɵnextContext().$implicit;
    const ctx_r216 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", (ctx_r216.inputData == null ? null : ctx_r216.inputData.visatype) === "ASYLUM" && item_r217.name ? (item1_r214.formType == null ? null : item1_r214.formType.name) + " (" + item_r217.name + ")" : (item1_r214.formType == null ? null : item1_r214.formType.name) + " (" + item_r217.firstName + " " + item_r217.lastName + ")", " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !item_r217.fileSrc && !item_r217.lastDocDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !item_r217.isGenerated && item_r217.isUploaded && item_r217.fileSrc && item_r217.lastDocDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r217.isGenerated && item_r217.isActive && item_r217.fileSrc && item_r217.lastDocDate);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", item_r217.fileSrc);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r217.fileSrc);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !item_r217.isGenerated && item_r217.isUploaded && item_r217.fileSrc);
} }
function GenerateFormsNewLibraryComponent_ng_container_23_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GenerateFormsNewLibraryComponent_ng_container_23_ng_container_1_tr_1_Template, 14, 7, "tr", 21);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item1_r214 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", item1_r214.applicantList);
} }
function GenerateFormsNewLibraryComponent_ng_container_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GenerateFormsNewLibraryComponent_ng_container_23_ng_container_1_Template, 2, 1, "ng-container", 21);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r11.dependentFormInfo == null ? null : ctx_r11.dependentFormInfo.generateFormFor);
} }
class GenerateFormsNewLibraryComponent {
    constructor(store, apiService, toastr, cdr) {
        this.store = store;
        this.apiService = apiService;
        this.toastr = toastr;
        this.cdr = cdr;
        this.showDependentVisaPdfGenerateSection = false;
        this.observableSubscription$ = new Subject();
        this.isThisGenerateFormForSection = false;
        this.dependentFormInfo = {};
        this.formDataArray = {
            common: [],
            primary: [],
            secondary: []
        };
        this.uploadedFormG28 = false;
        this.generateFormG28 = true;
        this.uploadedFormI907 = false;
        this.generateFormI907 = true;
        this.uploadedFormI129 = false;
        this.generateFormI129 = true;
        this.uploadedFormI130 = false;
        this.generateFormI130 = true;
        this.uploadedFormI130A = false;
        this.generateFormI130A = true;
        this.uploadedFormI130PREP = false;
        this.generateFormI130Prep = true;
        this.uploadedFormI130Intptr = false;
        this.generateFormI130INTPTR = true;
        this.generateFormI140 = true;
        this.uploadedFormI140 = false;
        this.acceptedTypes = acceptedFileTypes;
        this.disabledControls = false;
        this.i140Src = '';
        this.g28Src = '';
        this.i907Src = '';
        this.i129Src = '';
        this.gcPDFSrc = '';
        this.i130Src = '';
        this.i130ASrc = '';
        this.gi145Src = '';
        this.gi140Src = '';
        this.i907lastDocDate = "";
        this.g28lastDocDate = "";
        this.i129LastDocDate = "";
        this.i130lastDocDate = "";
        this.i130AlastDocDate = "";
        // this.gi145lastDocDate = ""; --
        this.gi140lastDocDate = "";
        this.g140lastDocDate = "";
        // this.docType = 'USCISFORMS'; --
        this.i130PrepSrc = '';
        this.i130PREPlastDocDate = '';
        this.i130IntptrSrc = '';
        this.i130INTPTRlastDocDate = '';
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
    ngOnInit() {
        var _a;
        if ((_a = this.inputData) === null || _a === void 0 ? void 0 : _a.stepId) {
            this.store.select(getSubTaskDetails).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                var _a, _b;
                this.subTaskDetails = data;
                this.USCISStepId = (_a = this.subTaskDetails.taskStepDetails.find(x => x.stepActionList[0].layoutCode === 'USCIS_CONTENT')) === null || _a === void 0 ? void 0 : _a.id;
                this.showI130InterperterSection = ((_b = this.subTaskDetails) === null || _b === void 0 ? void 0 : _b.isInterpreterReqd) === 'YES';
                this.cdr.detectChanges();
                this.onChanges();
            });
        }
        else {
            this.getGformInfo();
            this.getGeneratedForms();
        }
    }
    onChanges() {
        var _a;
        if ((_a = this.inputData) === null || _a === void 0 ? void 0 : _a.stepId) {
            const stepDetails$ = this.store.pipe(select(getStepDetails, { id: this.USCISStepId }));
            const inputStepDetails$ = this.store.pipe(select(getStepDetails, { id: this.inputData.stepId }));
            const GFormInfo$ = this.apiService.getEnotificationAndCCDetails(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId);
            combineLatest([stepDetails$, inputStepDetails$, GFormInfo$])
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe(([uscisStepDetails, inputStepDetails, GFormInfo]) => {
                this.stepDetails = inputStepDetails;
                this.USCISStepDetails = uscisStepDetails;
                if (GFormInfo.status === 200) {
                    this.enotificationAndCCDetails = GFormInfo.data;
                }
                this.toggleControlsStatus();
                if (this.USCISStepDetails && this.USCISStepDetails.additionalConfig) {
                    let additionalConfig = JSON.parse(this.USCISStepDetails.additionalConfig);
                    if (additionalConfig.uscisStepConfig) {
                        const showGenerateFormsObj = additionalConfig.uscisStepConfig.find(x => x.name === 'Show Generate Forms');
                        this.showDependentVisaPdfGenerateSection = (showGenerateFormsObj && showGenerateFormsObj.value && showGenerateFormsObj.showDependentForm) || ['APPLN400', 'APPLADCARDIMM'].includes(this.inputData.immigrationClassification) ? true : false;
                    }
                }
                else {
                    this.showDependentVisaPdfGenerateSection = DEPENDENT_VISAS.includes(this.inputData.visatype) || ['APPLADCARDNONIM', 'ASYLUM'].includes(this.inputData.visatype) || ['TRVLDOCI131', 'REMVCONDTRES', 'WVRUNLAWPRSNCI601A', 'WVRINADMI601', 'DACAI821D', 'AMERASIANI360', 'WIDOWERUSI360', 'VAWASPOUSEI360', 'VAWACHILDI360', 'VAWAPARENTI360', 'EB4IMMJUVNL', 'EB4IMMRELGWRKR', 'EB4IMMOTH', 'AFFDVTSUPT864', 'AFFDVTSUPTEXMPT864W', 'TEMPPROTSTATI821', 'RELFFORMERSEC191', 'SUSPDPRT881', 'APPLN400', 'APPLTOREPLRESICARD', 'APPLADCARDIMM'].includes(this.inputData.immigrationClassification) || this.inputData.getTaskType === 'I485';
                }
                if (this.showDependentVisaPdfGenerateSection) {
                    this.getDependentFormInfo();
                }
                else {
                    this.getGeneratedForms();
                }
            });
        }
        else {
            this.getGformInfo();
            this.getGeneratedForms();
        }
    }
    getGformInfo() {
        this.apiService.getEnotificationAndCCDetails(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response.status === 200) {
                this.enotificationAndCCDetails = response.data;
                //  console.log("$$$ this.enotificationAndCCDetails", this.enotificationAndCCDetails);
            }
        });
    }
    toggleControlsStatus() {
        this.disabledControls =
            this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" ||
                this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" ||
                this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT";
    }
    getDependentFormInfo() {
        this.apiService.getDependentFormInfo(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            var _a, _b, _c, _d, _e;
            try {
                if (this.inputData.getTaskType === 'I485' || response.data.generateFormFor) {
                    this.isThisGenerateFormForSection = ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.generateFormFor) ? true : false;
                    this.dependentFormInfo = response.data;
                    if (this.dependentFormInfo.generateFormFor.length > 0) {
                        this.dependentFormInfo.generateFormFor.forEach((element) => {
                            if (element.applicantList && element.applicantList.length > 0) {
                                element.applicantList.forEach((ele) => {
                                    ele.isGenerated = true;
                                    ele.isUploaded = false;
                                });
                                this.getGeneratedForms();
                            }
                        });
                    }
                }
                else {
                    this.dependentFormInfo = response.data;
                    const primaryApplicant = this.inputData.immigrationClassification && this.inputData.immigrationClassification === "AFFDVTSUPT864" ? (this.dependentFormInfo.primaryApplicantList).find(item => item.primaryApplicant) : this.dependentFormInfo.primaryApplicantList ? (this.dependentFormInfo.primaryApplicantList).find(item => item.primaryApplicant) : (this.dependentFormInfo.applicantList).find(item => item.primaryApplicant);
                    const secondaryApplicant = (this.dependentFormInfo.applicantList).filter(item => !item.primaryApplicant);
                    const secondaryApplicantNameList = secondaryApplicant.map(function (ele) {
                        return {
                            applicantName: ele.firstName ? `${ele.firstName} ${ele.lastName}` : null, applicantId: ele.id, isGenerated: true, isUploaded: false, relationshipCode: ele.relationshipCode, relationshipName: ele.relationshipName
                        };
                    });
                    this.formDataArray.common = this.dependentFormInfo.formTypes.common;
                    if (this.dependentFormInfo.formTypes && ((_c = (_b = this.dependentFormInfo.formTypes) === null || _b === void 0 ? void 0 : _b.primary) === null || _c === void 0 ? void 0 : _c.length) > 0) {
                        this.formDataArray.primary = this.dependentFormInfo.formTypes.primary.map(function (ele) {
                            return Object.assign(Object.assign({}, ele), { applicantName: (primaryApplicant === null || primaryApplicant === void 0 ? void 0 : primaryApplicant.firstName) ? `${primaryApplicant === null || primaryApplicant === void 0 ? void 0 : primaryApplicant.firstName} ${primaryApplicant === null || primaryApplicant === void 0 ? void 0 : primaryApplicant.lastName}` : null, applicantId: primaryApplicant === null || primaryApplicant === void 0 ? void 0 : primaryApplicant.id, isGenerated: true, isUploaded: false, relationshipCode: primaryApplicant === null || primaryApplicant === void 0 ? void 0 : primaryApplicant.relationshipCode, relationshipName: primaryApplicant === null || primaryApplicant === void 0 ? void 0 : primaryApplicant.relationshipName });
                        });
                    }
                    if (this.dependentFormInfo.formTypes && ((_e = (_d = this.dependentFormInfo.formTypes) === null || _d === void 0 ? void 0 : _d.secondary) === null || _e === void 0 ? void 0 : _e.length) > 0) {
                        this.formDataArray.secondary = this.dependentFormInfo.formTypes.secondary.map(function (ele) {
                            return Object.assign(Object.assign({}, ele), { secondaryApplicantNameList: secondaryApplicantNameList });
                        });
                    }
                }
                this.getGeneratedForms();
            }
            catch (error) {
                console.log("error outside", error);
            }
        });
    }
    getGeneratedForms() {
        this.apiService.getGeneratedFormDocuments(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, 'PETFORMDOC')
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response.status == 200 && response.data) {
                response.data.forEach((element) => {
                    var _a;
                    if (element.fileCategory && element.fileCategory.code === 'G28') {
                        let getFlag = localStorage.getItem("overrideRadioG28");
                        let isGenerated = JSON.parse(getFlag);
                        this.g28Src = element['fileLocation'] || '';
                        this.g28lastDocDate = element['generatedOn'] ? element['generatedOn'] : '';
                        this.fileName_g28 = element.fileCategory.code || ((_a = this.inputData) === null || _a === void 0 ? void 0 : _a.attorneyId);
                        this.documentIdG28 = element.id;
                        this.uploadedFormG28 = element.isUploaded;
                        this.uploadedFileNameG28 = element.uploadedFileName;
                        this.generateActiveG28 = element.isActive;
                        if (isGenerated && isGenerated.key == 'G28') {
                            this.generateFormG28 = isGenerated.isGenerate;
                        }
                        else {
                            this.generateFormG28 = element.isGenerated;
                        }
                    }
                    if (element.fileCategory && element.fileCategory.code === 'I907') {
                        let getFlag = localStorage.getItem("overrideRadioI907");
                        let isGenerated = JSON.parse(getFlag);
                        this.i907Src = element['fileLocation'] || '';
                        this.i907lastDocDate = element['generatedOn'] ? element['generatedOn'] : '';
                        this.fileName_907 = element.fileCategory.code;
                        this.documentId907 = element.id;
                        this.uploadedFormI907 = element.isUploaded;
                        this.uploadedFileName907 = element.uploadedFileName;
                        this.generateActive907 = element.isActive;
                        if (isGenerated && isGenerated.key == 'I907') {
                            this.generateFormI907 = isGenerated.isGenerate;
                        }
                        else {
                            this.generateFormI907 = element.isGenerated;
                        }
                    }
                    if (element.fileCategory && element.fileCategory.code === 'I140') {
                        this.i140Src = element['fileLocation'] || '';
                        this.gi140lastDocDate = element['generatedOn'] ? element['generatedOn'] : '';
                        this.fileName_140 = element.fileCategory.code;
                    }
                    if (element.fileCategory && element.fileCategory.code === 'I129') {
                        let getFlag = localStorage.getItem("overrideRadioI129");
                        let isGenerated = JSON.parse(getFlag);
                        this.i129Src = element['fileLocation'] || '';
                        this.i129LastDocDate = element['generatedOn'] ? element['generatedOn'] : '';
                        this.fileName_129 = element.fileCategory.code;
                        this.documentId129 = element.id;
                        this.uploadedFormI129 = element.isUploaded;
                        this.uploadedFileName129 = element.uploadedFileName;
                        this.generateActive129 = element.isActive;
                        if (isGenerated && isGenerated.key == 'I129') {
                            this.generateFormI129 = isGenerated.isGenerate;
                        }
                        else {
                            this.generateFormI129 = element.isGenerated;
                        }
                    }
                    if (element.fileCategory && element.fileCategory.code === 'I130') {
                        let getFlag = localStorage.getItem("overrideRadioI130");
                        let isGenerated = JSON.parse(getFlag);
                        this.i130Src = element['fileLocation'] || '';
                        this.i130lastDocDate = element['generatedOn'] ? element['generatedOn'] : '';
                        this.fileName_130 = element.fileCategory.code;
                        this.documentId130 = element.id;
                        this.uploadedFormI130 = element.isUploaded;
                        this.uploadedFileName130 = element.uploadedFileName;
                        this.generateActive130 = element.isActive;
                        if (isGenerated && isGenerated.key == 'I130') {
                            this.generateFormI130 = isGenerated.isGenerate;
                        }
                        else {
                            this.generateFormI130 = element.isGenerated;
                        }
                    }
                    if (element.fileCategory && element.fileCategory.code === 'I130A') {
                        let getFlag = localStorage.getItem("overrideRadioI130A");
                        let isGenerated = JSON.parse(getFlag);
                        this.i130ASrc = element['fileLocation'] || '';
                        this.i130AlastDocDate = element['generatedOn'] ? element['generatedOn'] : '';
                        this.fileName_130A = element.fileCategory.code;
                        this.documentId130A = element.id;
                        this.uploadedFormI130A = element.isUploaded;
                        this.uploadedFileName130A = element.uploadedFileName;
                        this.generateActive130A = element.isActive;
                        if (isGenerated && isGenerated.key == 'I130A') {
                            this.generateFormI130A = isGenerated.isGenerate;
                        }
                        else {
                            this.generateFormI130A = element.isGenerated;
                        }
                    }
                    if (element.fileCategory && element.fileCategory.code === 'G1145') {
                        this.gi145Src = element['fileLocation'] || '';
                        this.gi145DocDate = element['generatedOn'] ? element['generatedOn'] : '';
                    }
                    if (element.fileCategory && element.fileCategory.code === 'G1450') {
                        this.gi140Src = element['fileLocation'] || '';
                        this.g140lastDocDate = element['generatedOn'] ? element['generatedOn'] : '';
                    }
                    if (element.fileCategory && element.fileCategory.code === 'I130PREP') {
                        let getFlag = localStorage.getItem("overrideRadioI130PREP");
                        let isGenerated = JSON.parse(getFlag);
                        this.i130PrepSrc = element['fileLocation'] || '';
                        this.i130PREPlastDocDate = element['generatedOn'] ? element['generatedOn'] : '';
                        this.fileName_i130Prep = element.fileCategory.code;
                        this.documentId130PREP = element.id;
                        this.uploadedFormI130PREP = element.isUploaded;
                        this.uploadedFileNameI130PREP = element.uploadedFileName;
                        this.generateActiveI130Prep = element.isActive;
                        if (isGenerated && isGenerated.key == 'I130PREP') {
                            this.generateFormI130Prep = isGenerated.isGenerate;
                        }
                        else {
                            this.generateFormI130Prep = element.isGenerated;
                        }
                    }
                    if (element.fileCategory && element.fileCategory.code === 'I130INTPTR') {
                        let getFlag = localStorage.getItem("overrideRadioI130INTPTR");
                        let isGenerated = JSON.parse(getFlag);
                        this.i130IntptrSrc = element['fileLocation'] || '';
                        this.i130INTPTRlastDocDate = element['generatedOn'] ? element['generatedOn'] : '';
                        this.fileName_i130Intptr = element.fileCategory.code;
                        this.documentId130INTPTR = element.id;
                        this.uploadedFormI130Intptr = element.isUploaded;
                        this.uploadedFileName130INTPTR = element.uploadedFileName;
                        this.generateActiveI130INTPTR = element.isActive;
                        if (isGenerated && isGenerated.key == 'I130INTPTR') {
                            this.generateFormI130INTPTR = isGenerated.isGenerate;
                        }
                        else {
                            this.generateFormI130INTPTR = element.isGenerated;
                        }
                    }
                });
                if (this.showDependentVisaPdfGenerateSection && this.inputData.getTaskType != 'I485' && !this.isThisGenerateFormForSection) {
                    const dependentResponse = response.data;
                    dependentResponse.forEach((element) => {
                        if (this.formDataArray.primary.length > 0) {
                            this.formDataArray.primary.forEach((ele) => {
                                if (element.fileCategory && element.fileCategory.code === ele.code) {
                                    ele.fileSrc = element['fileLocation'] || '';
                                    ele.lastDocDate = element['generatedOn'] ? element['generatedOn'] : '';
                                    ele.isGenerated = element.isGenerated;
                                    ele.isUploaded = element.isUploaded;
                                    ele.documentId = element.id;
                                    ele.familyId = element.familyId;
                                    ele.uploadedFileName = element.uploadedFileName;
                                    ele.isActive = element.isActive;
                                }
                            });
                        }
                        if (this.formDataArray.secondary.length > 0) {
                            this.formDataArray.secondary[0].secondaryApplicantNameList.forEach((ele) => {
                                if (element.fileCategory && element.fileCategory.code === this.formDataArray.secondary[0].code && element.familyId === ele.applicantId) {
                                    ele.fileSrc = element['fileLocation'] || '';
                                    ele.lastDocDate = element['generatedOn'] ? element['generatedOn'] : '';
                                    ele.isGenerated = element.isGenerated;
                                    ele.isUploaded = element.isUploaded;
                                    ele.documentId = element.id;
                                    ele.familyId = element.familyId;
                                    ele.uploadedFileName = element.uploadedFileName;
                                    ele.isActive = element.isActive;
                                }
                            });
                        }
                        if (this.formDataArray.common.length > 0) {
                            this.formDataArray.common.forEach((ele) => {
                                if (element.fileCategory && element.fileCategory.code === ele.code) {
                                    ele.fileSrc = element['fileLocation'] || '';
                                    ele.lastDocDate = element['generatedOn'] ? element['generatedOn'] : '';
                                    ele.isGenerated = element.isGenerated;
                                    ele.isUploaded = element.isUploaded;
                                    ele.documentId = element.id;
                                    ele.familyId = element.familyId;
                                    ele.uploadedFileName = element.uploadedFileName;
                                    ele.isActive = element.isActive;
                                }
                            });
                        }
                    });
                }
                if (this.inputData.getTaskType === 'I485' || this.isThisGenerateFormForSection) {
                    const dependentResponse = response.data;
                    dependentResponse.forEach((element) => {
                        if (this.dependentFormInfo.generateFormFor.length > 0) {
                            this.dependentFormInfo.generateFormFor.forEach((ele) => {
                                if (ele.applicantList && ele.applicantList.length > 0 && element.fileCategory && element.fileCategory.code === ele.formType.code) {
                                    ele.applicantList.forEach((item) => {
                                        if (item.relationshipCode && element.familyId === item.id) {
                                            item.fileSrc = element['fileLocation'] || '';
                                            item.lastDocDate = element['generatedOn'] ? element['generatedOn'] : '';
                                            item.isGenerated = element.isGenerated;
                                            item.isUploaded = element.isUploaded;
                                            item.documentId = element.id;
                                            item.familyId = element.familyId;
                                            item.isActive = element.isActive;
                                            item.uploadedFileName = element.uploadedFileName;
                                        }
                                        else if (!item.relationshipCode && !element.familyId && element.fileCategory.code !== 'G28') {
                                            item.fileSrc = element['fileLocation'] || '';
                                            item.lastDocDate = element['generatedOn'] ? element['generatedOn'] : '';
                                            item.isGenerated = element.isGenerated;
                                            item.isUploaded = element.isUploaded;
                                            item.documentId = element.id;
                                            item.familyId = element.familyId;
                                            item.isActive = element.isActive;
                                            item.uploadedFileName = element.uploadedFileName;
                                        }
                                    });
                                }
                            });
                        }
                    });
                    // console.log("this.dependentFormInfo",this.dependentFormInfo);
                }
            }
        });
    }
    viewGenerateDoc(src) {
        const docPath = src.substring(23);
        window.open(`${environment.docs}${docPath}`, '_blank');
    }
    downloadGenerateDoc(src) {
        // const docPath = src.substring(23);
        // const downloadUrl = `${environment.docs}${docPath}`;
        // const link = document.createElement('a');
        // link.href = downloadUrl;
        // link.download = docPath.split('/').pop();
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
        const docPath = src.substring(23);
        const downloadUrl = `${environment.docs}${docPath}`;
        fetch(downloadUrl)
            .then(response => response.blob()) // Get file as Blob
            .then(blob => {
            const blobUrl = window.URL.createObjectURL(blob); // Create a blob URL
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = docPath.split('/').pop(); // Extract filename
            document.body.appendChild(link);
            link.click();
            // Clean up
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        })
            .catch(error => console.error('Download failed:', error));
    }
    postGenerateDoc(gcFormtype) {
        if (gcFormtype === 'I129' && this.inputData.taskTypeSaveJsonId && !['H3B', 'H3A', 'E3'].includes(this.inputData.getTaskType)) {
            this.postDependentGenerateDoc(gcFormtype, 0, 'false', null);
        }
        else {
            const payload = {
                formType: gcFormtype,
            };
            this.apiService.postFormType(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.inputData.superTaskId, this.inputData.subTaskId, gcFormtype, payload)
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe((response) => {
                if (response.data) {
                    this.gcPDFSrc = response.data['fileLocation'] || '';
                    if (this.gcPDFSrc != '') {
                        const date = response.data['generatedOn'] ? response.data['generatedOn'] : '';
                        const src = this.gcPDFSrc;
                        const isActive = response.data.isActive;
                        const isGenerated = response.data.isGenerated;
                        const isUploaded = response.data.isUploaded;
                        this.assignFileSrcAndDate(gcFormtype, date, src, isActive, isGenerated, isUploaded);
                        this.toastr.success(response.message, "Success"); // all done
                        this.getGeneratedForms();
                    }
                }
            });
        }
    }
    postDependentGenerateDoc(formType, id, generateAll, relationshipCode) {
        var _a;
        const applicantList = [];
        if (generateAll === 'true' || (this.inputData.visatype === 'ASYLUM' && this.inputData.immigrationClassification !== 'ASYLRELATIVE' && ((_a = this.dependentFormInfo.applicantList) === null || _a === void 0 ? void 0 : _a.length) > 0)) {
            const secondaryApplicants = this.dependentFormInfo.applicantList.filter(item => !item.primaryApplicant);
            applicantList.push(...secondaryApplicants.map(({ id }) => id));
        }
        else if (id && relationshipCode) {
            applicantList.push(id);
        }
        this.generateForm(formType, generateAll, relationshipCode, applicantList);
    }
    generateForm(formType, generateAll, relationshipCode, applicantList) {
        let applicatListVal;
        // const formTypeVal = this.inputData.caseType === "I129EFILING" ? 'I129preparer' : formType;
        if ((this.inputData.visatype === 'ASYLUM') || relationshipCode === null) {
            if ((this.inputData.immigrationClassification != "ASYLRELATIVE" && (applicantList === null || applicantList === void 0 ? void 0 : applicantList.length) === 0) || (formType === 'I589' && this.inputData.immigrationClassification === "ASYLAFFIRM")) {
                applicatListVal = [];
            }
            else {
                applicatListVal = applicantList;
            }
        }
        else {
            applicatListVal = applicantList;
        }
        const payload = {
            "applicantList": applicatListVal,
            "generateAll": generateAll === 'true' ? true : false
        };
        this.apiService.postDependentFormType(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.inputData.subTaskId, formType, payload)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response.data) {
                this.toastr.success(response.message, "Success");
                this.getGeneratedForms();
            }
        });
    }
    assignFileSrcAndDate(type, date, src, isActive, isGenerated, isUploaded) {
        if (type === 'I140') {
            this.i140Src = src;
            this.gi140lastDocDate = date;
            this.generateFormI140 = isGenerated;
            this.generateActive140 = isActive;
            this.uploadedFormI140 = isUploaded;
        }
        if (type === 'I907') {
            this.i907Src = src;
            this.i907lastDocDate = date;
            this.generateFormI907 = isGenerated;
            this.generateActive907 = isActive;
            this.uploadedFormI907 = isUploaded;
        }
        if (type === 'G28') {
            this.g28Src = src;
            this.g28lastDocDate = date;
            this.generateFormG28 = isGenerated;
            this.generateActiveG28 = isActive;
            this.uploadedFormG28 = isUploaded;
        }
        if (type === 'I129') {
            this.i129Src = src;
            this.i129LastDocDate = date;
            this.generateFormI129 = isGenerated;
            this.generateActive129 = isActive;
            this.uploadedFormI129 = isUploaded;
        }
        if (type === 'I130') {
            this.i130Src = src;
            this.i130lastDocDate = date;
            this.generateFormI130 = isGenerated;
            this.generateActive130 = isActive;
            this.uploadedFormI130 = isUploaded;
        }
        if (type === 'I130A') {
            this.i130ASrc = src;
            this.i130AlastDocDate = date;
            this.generateFormI130A = isGenerated;
            this.generateActive130A = isActive;
            this.uploadedFormI130A = isUploaded;
        }
        if (type === 'G1450') {
            this.gi140Src = src;
            this.g140lastDocDate = date;
        }
        if (type === 'G1145') {
            this.gi145Src = src;
            this.gi145DocDate = date;
        }
    }
    deleteUploadedDocument(formName, documentId, formType, currentIndex, subIndex) {
        if (this.inputData.caseType == "I130") {
            this.apiService.deleteGreenCardUploadDocument(documentId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                this.toastr.success(response.message, "Success");
                let documentId = response.data.id;
                let fileName = response.data.fileCategory.code;
                // let generatedOn = response.data.generatedOn;
                let isGenerated = response.data.isGenerated;
                let isUploaded = response.data.isUploaded;
                // let getURL = response.data.fileLocation;
                // let formType = this.formType;
                // let currentIndex = this.currentIndex;
                // let subIndex = this.subIndex;
                let familyId = response.data.familyId;
                localStorage.setItem("overrideRadioG28", null);
                localStorage.setItem("overrideRadioI129", null);
                localStorage.setItem("overrideRadioI907", null);
                localStorage.setItem("overrideRadioI130", null);
                localStorage.setItem("overrideRadioI130A", null);
                localStorage.setItem("overrideRadioI130PREP", null);
                localStorage.setItem("overrideRadioI130INTPTR", null);
                this.assignLatestValues({ familyId: familyId, fileName: fileName, documentID: documentId, generatedOn: null, isGenerated: isGenerated, isUploaded: isUploaded, getUrl: null, formType: formType, currentIndex: currentIndex, subIndex: subIndex });
            });
        }
        else {
            this.apiService.deleteUploadDocument(documentId, this.inputData.companyId, this.inputData.petitionId)
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe((response) => {
                if (response.status == 200) {
                    this.toastr.success(response.message, "Success");
                    let documentId = response.data.id;
                    let fileName = response.data.fileCategory.code;
                    // let generatedOn = response.data.generatedOn;
                    let isGenerated = response.data.isGenerated;
                    let isUploaded = response.data.isUploaded;
                    // let getURL = response.data.fileLocation;
                    // let formType = this.formType;
                    // let currentIndex = this.currentIndex;
                    // let subIndex = this.subIndex;
                    let familyId = response.data.familyId;
                    localStorage.setItem("overrideRadioG28", null);
                    localStorage.setItem("overrideRadioI129", null);
                    localStorage.setItem("overrideRadioI907", null);
                    localStorage.setItem("overrideRadioI130", null);
                    localStorage.setItem("overrideRadioI130A", null);
                    localStorage.setItem("overrideRadioI130PREP", null);
                    localStorage.setItem("overrideRadioI130INTPTR", null);
                    this.assignLatestValues({ familyId: familyId, fileName: fileName, documentID: documentId, generatedOn: null, isGenerated: isGenerated, isUploaded: isUploaded, getUrl: null, formType: formType, currentIndex: currentIndex, subIndex: subIndex });
                }
            });
        }
    }
    triggerFileUpload(formType, currentIndex, subIndex, familyId, formName) {
        this.uploadFormType = formType;
        this.uploadCurrentIndex = currentIndex;
        this.uploadSubIndex = subIndex;
        this.uploadFamilyId = familyId;
        this.uploadFormName = formName;
        this.fileInput.nativeElement.click();
    }
    uploadForm(_data) {
        let files = _data[0];
        // if (files.type !== 'application/pdf') {
        //   this.toastr.error("You have selected wrong document", "Please upload PDF file")
        // }
        // else {
        this.selectedFile = files;
        const formData = new FormData();
        formData.append('file', this.selectedFile);
        if (!this.uploadFamilyId) {
            this.uploadFamilyId = '';
        }
        this.apiService.uploadDocument(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.inputData.superTaskId, this.inputData.subTaskId, this.uploadFormName, this.uploadFamilyId, formData)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response.status == 200) {
                this.toastr.success(response.message, "Success");
                let documentId = response.data.id;
                let fileName = response.data.fileCategory.code;
                let generatedOn = response.data.generatedOn;
                let isGenerated = response.data.isGenerated;
                let isUploaded = response.data.isUploaded;
                let getURL = response.data.fileLocation;
                // let formType = this.formType;
                // let currentIndex = this.currentIndex;
                // let subIndex = this.subIndex;
                let uploadedFileName = response.data.uploadedFileName;
                let generateActive = response.data.isActive;
                let familyId = response.data.familyId;
                this.assignLatestValues({
                    familyId: familyId,
                    fileName: fileName,
                    documentID: documentId,
                    generatedOn: generatedOn,
                    isGenerated: isGenerated,
                    isUploaded: isUploaded,
                    getUrl: getURL,
                    formType: this.uploadFormType,
                    currentIndex: this.uploadCurrentIndex,
                    subIndex: this.uploadSubIndex,
                    uploadedFileName: uploadedFileName,
                    isActive: generateActive
                });
            }
            this.fileInput.nativeElement.value = "";
            this.selectedFile = null;
        });
    }
    assignLatestValues(_data) {
        if (_data.fileName == 'I129') {
            this.generateFormI129 = _data.isGenerated;
            this.uploadedFormI129 = _data.isUploaded;
            this.i129LastDocDate = _data.generatedOn;
            this.documentId129 = _data.documentID;
            this.i129Src = _data.getUrl;
            this.uploadedFileName129 = _data.uploadedFileName;
            this.generateActive129 = _data.isActive;
        }
        else if (_data.fileName == 'I907') {
            this.generateFormI907 = _data.isGenerated;
            this.uploadedFormI907 = _data.isUploaded;
            this.i907lastDocDate = _data.generatedOn;
            this.documentId907 = _data.documentID;
            this.i907Src = _data.getUrl;
            this.uploadedFileName907 = _data.uploadedFileName;
            this.generateActive907 = _data.isActive;
        }
        else if (_data.fileName == 'G28') {
            this.generateFormG28 = _data.isGenerated;
            this.uploadedFormG28 = _data.isUploaded;
            this.g28lastDocDate = _data.generatedOn;
            this.documentIdG28 = _data.documentID;
            this.g28Src = _data.getUrl;
            this.uploadedFileNameG28 = _data.uploadedFileName;
            this.generateActiveG28 = _data.isActive;
        }
        else if (_data.fileName == 'I130') {
            this.generateFormI130 = _data.isGenerated;
            this.uploadedFormI130 = _data.isUploaded;
            this.i130lastDocDate = _data.generatedOn;
            this.documentId130 = _data.documentID;
            this.i130Src = _data.getUrl;
            this.uploadedFileName130 = _data.uploadedFileName;
            this.generateActive130 = _data.isActive;
        }
        else if (_data.fileName == 'I130A') {
            this.generateFormI130A = _data.generatedOn;
            this.uploadedFormI130A = _data.isUploaded;
            this.i130AlastDocDate = _data.generatedOn;
            this.documentId130A = _data.documentID;
            this.i130ASrc = _data.getUrl;
            this.uploadedFileName130A = _data.uploadedFileName;
            this.generateActive130A = _data.isActive;
        }
        else if (_data.fileName == 'I130PREP') {
            this.generateFormI130Prep = _data.generatedOn;
            this.uploadedFormI130PREP = _data.isUploaded;
            this.i130PREPlastDocDate = _data.generatedOn;
            this.documentId130PREP = _data.documentID;
            this.i130PrepSrc = _data.getUrl;
            this.uploadedFileNameI130PREP = _data.uploadedFileName;
            this.generateActiveI130Prep = _data.isActive;
        }
        else if (_data.fileName == 'I130INTPTR') {
            this.generateFormI130INTPTR = _data.generatedOn;
            this.uploadedFormI130INTPTR = _data.isUploaded;
            this.i130INTPTRlastDocDate = _data.generatedOn;
            this.documentId130INTPTR = _data.documentID;
            this.i130IntptrSrc = _data.getUrl;
            this.uploadedFileName130INTPTR = _data.uploadedFileName;
            this.generateActiveI130INTPTR = _data.isActive;
        }
        else {
            if (_data.formType == 'primary') {
                this.formDataArray.primary[_data.currentIndex].isGenerated = _data.isGenerated;
                this.formDataArray.primary[_data.currentIndex].isUploaded = _data.isUploaded;
                this.formDataArray.primary[_data.currentIndex].documentId = _data.documentID;
                this.formDataArray.primary[_data.currentIndex].fileSrc = _data.getUrl;
                this.formDataArray.primary[_data.currentIndex].lastDocDate = _data.generatedOn;
                this.formDataArray.primary[_data.currentIndex].uploadedFileName = _data.uploadedFileName;
                this.formDataArray.primary[_data.currentIndex].isActive = _data.isActive;
            }
            else if (_data.formType == 'secondary') {
                this.formDataArray.secondary[0].secondaryApplicantNameList[_data.currentIndex].isGenerated = _data.isGenerated;
                this.formDataArray.secondary[0].secondaryApplicantNameList[_data.currentIndex].isUploaded = _data.isUploaded;
                this.formDataArray.secondary[0].secondaryApplicantNameList[_data.currentIndex].documentId = _data.documentID;
                this.formDataArray.secondary[0].secondaryApplicantNameList[_data.currentIndex].fileSrc = _data.getUrl;
                this.formDataArray.secondary[0].secondaryApplicantNameList[_data.currentIndex].lastDocDate = _data.generatedOn;
                this.formDataArray.secondary[0].secondaryApplicantNameList[_data.currentIndex].uploadedFileName = _data.uploadedFileName;
                this.formDataArray.secondary[0].secondaryApplicantNameList[_data.currentIndex].isActive = _data.isActive;
            }
            else if (_data.formType == 'dependentForm') {
                this.dependentFormInfo.generateFormFor[_data.currentIndex].applicantList[_data.subIndex].isGenerated = _data.isGenerated;
                this.dependentFormInfo.generateFormFor[_data.currentIndex].applicantList[_data.subIndex].isUploaded = _data.isUploaded;
                this.dependentFormInfo.generateFormFor[_data.currentIndex].applicantList[_data.subIndex].lastDocDate = _data.generatedOn;
                this.dependentFormInfo.generateFormFor[_data.currentIndex].applicantList[_data.subIndex].documentId = _data.documentID;
                this.dependentFormInfo.generateFormFor[_data.currentIndex].applicantList[_data.subIndex].fileSrc = _data.getUrl;
                this.dependentFormInfo.generateFormFor[_data.currentIndex].applicantList[_data.subIndex].uploadedFileName = _data.uploadedFileName;
                this.dependentFormInfo.generateFormFor[_data.currentIndex].applicantList[_data.subIndex].isActive = _data.isActive;
            }
            else if (_data.formType == 'common') {
                this.formDataArray.common[_data.currentIndex].isGenerated = _data.isGenerated;
                this.formDataArray.common[_data.currentIndex].isUploaded = _data.isUploaded;
                this.formDataArray.common[_data.currentIndex].documentId = _data.documentID;
                this.formDataArray.common[_data.currentIndex].fileSrc = _data.getUrl;
                this.formDataArray.common[_data.currentIndex].lastDocDate = _data.generatedOn;
                this.formDataArray.common[_data.currentIndex].uploadedFileName = _data.uploadedFileName;
                this.formDataArray.common[_data.currentIndex].isActive = _data.isActive;
            }
        }
    }
}
GenerateFormsNewLibraryComponent.ɵfac = function GenerateFormsNewLibraryComponent_Factory(t) { return new (t || GenerateFormsNewLibraryComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.APIGenerateForms), i0.ɵɵdirectiveInject(i3.ToastrService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
GenerateFormsNewLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: GenerateFormsNewLibraryComponent, selectors: [["lib-generate-forms-new-library"]], viewQuery: function GenerateFormsNewLibraryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 1);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fileInput = _t.first);
    } }, inputs: { inputData: "inputData" }, decls: 24, vars: 13, consts: [[1, "title"], ["type", "file", "name", "myfile", "hidden", "", 3, "accept", "disabled", "change"], ["fileInput", ""], [1, "table-container"], [4, "ngIf"], ["class", "status not-generated", 4, "ngIf"], ["class", "status uploaded", 4, "ngIf"], ["class", "status generated", 4, "ngIf"], [1, "actions"], ["pTooltip", "Upload", "tooltipPosition", "left", 1, "pi", "pi-upload", 3, "click"], ["pTooltip", "Generate", "tooltipPosition", "left", 3, "click"], ["src", "assets/images/generate.png", "alt", "", 1, "generate-img"], ["class", "pi pi-eye", "pTooltip", "View", "tooltipPosition", "left", 3, "click", 4, "ngIf"], ["class", "pi pi-download", "pTooltip", "Download", "tooltipPosition", "left", 3, "click", 4, "ngIf"], ["class", "pi pi-trash", "pTooltip", "Delete", "tooltipPosition", "left", 3, "click", 4, "ngIf"], [1, "status", "not-generated"], [1, "status", "uploaded"], [1, "status", "generated"], ["pTooltip", "View", "tooltipPosition", "left", 1, "pi", "pi-eye", 3, "click"], ["pTooltip", "Download", "tooltipPosition", "left", 1, "pi", "pi-download", 3, "click"], ["pTooltip", "Delete", "tooltipPosition", "left", 1, "pi", "pi-trash", 3, "click"], [4, "ngFor", "ngForOf"]], template: function GenerateFormsNewLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtext(1, "Generate Petition Forms");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "input", 1, 2);
        i0.ɵɵlistener("change", function GenerateFormsNewLibraryComponent_Template_input_change_2_listener($event) { return ctx.uploadForm($event.target.files); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelementStart(5, "table");
        i0.ɵɵelementStart(6, "tr");
        i0.ɵɵelementStart(7, "th");
        i0.ɵɵtext(8, "Form");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "th");
        i0.ɵɵtext(10, "Status");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "th");
        i0.ɵɵtext(12, "Actions");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(13, GenerateFormsNewLibraryComponent_tr_13_Template, 14, 6, "tr", 4);
        i0.ɵɵtemplate(14, GenerateFormsNewLibraryComponent_tr_14_Template, 14, 6, "tr", 4);
        i0.ɵɵtemplate(15, GenerateFormsNewLibraryComponent_tr_15_Template, 14, 6, "tr", 4);
        i0.ɵɵtemplate(16, GenerateFormsNewLibraryComponent_tr_16_Template, 11, 4, "tr", 4);
        i0.ɵɵtemplate(17, GenerateFormsNewLibraryComponent_tr_17_Template, 11, 4, "tr", 4);
        i0.ɵɵtemplate(18, GenerateFormsNewLibraryComponent_tr_18_Template, 14, 6, "tr", 4);
        i0.ɵɵtemplate(19, GenerateFormsNewLibraryComponent_tr_19_Template, 14, 6, "tr", 4);
        i0.ɵɵtemplate(20, GenerateFormsNewLibraryComponent_tr_20_Template, 14, 6, "tr", 4);
        i0.ɵɵtemplate(21, GenerateFormsNewLibraryComponent_tr_21_Template, 14, 6, "tr", 4);
        i0.ɵɵtemplate(22, GenerateFormsNewLibraryComponent_ng_container_22_Template, 4, 3, "ng-container", 4);
        i0.ɵɵtemplate(23, GenerateFormsNewLibraryComponent_ng_container_23_Template, 2, 1, "ng-container", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("accept", ctx.acceptedTypes)("disabled", ctx.disabledControls);
        i0.ɵɵadvance(11);
        i0.ɵɵproperty("ngIf", (ctx.inputData == null ? null : ctx.inputData.caseType) != "I130" && !ctx.showDependentVisaPdfGenerateSection);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.subTaskDetails == null ? null : ctx.subTaskDetails.serviceCenterDetails == null ? null : ctx.subTaskDetails.serviceCenterDetails.isPremiumCenter) === 1 && (ctx.inputData == null ? null : ctx.inputData.caseType) != "I130" && ctx.formDataArray.common.length === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.inputData == null ? null : ctx.inputData.attorneyId) && (ctx.inputData == null ? null : ctx.inputData.caseType) !== "I129EFILING" && (ctx.inputData == null ? null : ctx.inputData.immigrationClassification) !== "APPLADCARDIMM" && (!ctx.showDependentVisaPdfGenerateSection || ((ctx.dependentFormInfo == null ? null : ctx.dependentFormInfo.formDetail) === null || (ctx.dependentFormInfo == null ? null : ctx.dependentFormInfo.formDetail == null ? null : ctx.dependentFormInfo.formDetail.govtAgencyCode) === "USCIS" && ctx.formDataArray.common.length === 0)));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.enotificationAndCCDetails == null ? null : ctx.enotificationAndCCDetails.isAuthCreditCardTrans) === 1);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.enotificationAndCCDetails == null ? null : ctx.enotificationAndCCDetails.isEnotifyReqd) === 1);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.inputData == null ? null : ctx.inputData.caseType) == "I130");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.inputData == null ? null : ctx.inputData.caseType) == "I130" && (ctx.inputData == null ? null : ctx.inputData.filingType) === "e-filing");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.inputData == null ? null : ctx.inputData.caseType) == "I130" && (ctx.inputData == null ? null : ctx.inputData.filingType) === "e-filing" && ctx.showI130InterperterSection);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.inputData == null ? null : ctx.inputData.caseType) == "I130" && ctx.inputData.relationshipCode && ctx.inputData.relationshipCode === "SPOUSE");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showDependentVisaPdfGenerateSection);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.inputData.getTaskType === "I485" || (ctx.dependentFormInfo == null ? null : ctx.dependentFormInfo.generateFormFor));
    } }, directives: [i4.NgIf, i5.Tooltip, i4.NgForOf], styles: [".title[_ngcontent-%COMP%]{font-size:17px;font-weight:600;background-color:#f4f4f4;margin:20px auto 2px;width:calc(100% - 60px);color:#626262;padding:15px}.table-container[_ngcontent-%COMP%]{width:calc(100% - 60px);margin:0 auto 20px;border:1px solid #eef4fa;overflow:hidden}table[_ngcontent-%COMP%]{width:100%;border-collapse:collapse;table-layout:fixed}tr[_ngcontent-%COMP%]:nth-child(odd)   td[_ngcontent-%COMP%]{background-color:#f8f9fa}td[_ngcontent-%COMP%], th[_ngcontent-%COMP%]{text-align:left;padding:12px}th[_ngcontent-%COMP%]{background-color:#edf4fb;border-bottom:2px solid #f0f5fa}td[_ngcontent-%COMP%]{border-bottom:1px solid #f0f5fa;font-size:12px}.status[_ngcontent-%COMP%]{align-items:center;gap:10px}.status.not-generated[_ngcontent-%COMP%]{color:red}.status.generated[_ngcontent-%COMP%], .status.uploaded[_ngcontent-%COMP%]{color:green}.actions[_ngcontent-%COMP%]{align-items:center;gap:10px}.actions[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{font-size:18px;line-height:20px;color:#555;float:left;margin-right:15px;cursor:pointer}.actions[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]   .generate-img[_ngcontent-%COMP%]{width:15px;height:20px;margin-top:-4px}.tooltip[_ngcontent-%COMP%]{margin:10px 0;font-size:14px;color:#555}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GenerateFormsNewLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'lib-generate-forms-new-library',
                templateUrl: 'generate-forms-new-library.component.html',
                styleUrls: ['generate-forms-new-library.component.scss']
            }]
    }], function () { return [{ type: i1.Store }, { type: i2.APIGenerateForms }, { type: i3.ToastrService }, { type: i0.ChangeDetectorRef }]; }, { inputData: [{
            type: Input
        }], fileInput: [{
            type: ViewChild,
            args: ['fileInput']
        }] }); })();

class GenerateFormsNewLibraryModule {
}
GenerateFormsNewLibraryModule.ɵfac = function GenerateFormsNewLibraryModule_Factory(t) { return new (t || GenerateFormsNewLibraryModule)(); };
GenerateFormsNewLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: GenerateFormsNewLibraryModule });
GenerateFormsNewLibraryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(GenerateFormsNewLibraryModule, { declarations: [GenerateFormsNewLibraryComponent], imports: [CommonModule,
        PrimengLibraryModule], exports: [GenerateFormsNewLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GenerateFormsNewLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [GenerateFormsNewLibraryComponent],
                imports: [
                    CommonModule,
                    PrimengLibraryModule
                ],
                exports: [GenerateFormsNewLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of generate-forms-new-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GenerateFormsNewLibraryComponent, GenerateFormsNewLibraryModule, GenerateFormsNewLibraryService };
//# sourceMappingURL=generate-forms-new-library.js.map
